import { Box, Chip, MenuItem, MenuList } from "@mui/material";

import { airlineBgColor } from "@/constants/config";
import {
  BANK_ALIAS_NAME_MAP,
  BANK_COLOR,
  PROGRAM_IMG,
  SORTED_ROUTE_PROGRAM_NAME_MAP,
} from "@/constants/programs";
import useThemeData from "@/hooks/useThemeData";
import { getBankNameByProgram } from "@/utils";

const ProgramBanks = (props: { onClick: (props: { programs: string }) => void }) => {
  const theme = useThemeData();
  return (
    <MenuList>
      {Array.from(SORTED_ROUTE_PROGRAM_NAME_MAP.entries()).map((item) => {
        const banks = getBankNameByProgram(item[0]).sort((a, b) => a.localeCompare(b));
        return (
          <MenuItem
            key={item[0]}
            sx={{ paddingY: "0px" }}
            onClick={() => {
              props.onClick({ programs: item[0] });
            }}
          >
            <Box
              className="rounded-[3px] p-[4px] w-[60px] mr-[10px]"
              sx={{
                backgroundColor: theme.isDarkMode ? airlineBgColor : "transparent",
              }}
            >
              <img className="w-[100%]" src={PROGRAM_IMG[item[0]]} alt="" />
            </Box>
            <div className="!w-[245px] fontweight-[1000]">{item[1]}</div>
            <div className="space-x-[6px] ml-[10px]">
              {banks.map((bankItem, index) => (
                <Chip
                  className="!cursor-pointer !w-[65px] !capitalize"
                  sx={{
                    borderRadius: "8px",
                    color: "#fff",
                    backgroundColor: BANK_COLOR[bankItem],
                    fontSize: "11px",
                    fontWeight: 900,
                  }}
                  size="small"
                  key={index}
                  label={BANK_ALIAS_NAME_MAP[bankItem]}
                />
              ))}
            </div>
          </MenuItem>
        );
      })}
    </MenuList>
  );
};
export default ProgramBanks;
